import React from 'react';
import ToggleVisibleBtn from '../../../commonComponents/ToggleVisibleBtn';
import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';
import custJqAjax from '../../../commonJS/custJqAjax';

import {
  Modal,
  Button,
  FormGroup,
  ControlLabel,
  Col,
  Row
} from 'react-bootstrap';


const DataImportModal = props => {
  const { languageData, languageCode } = window.myConsts;

  let
    cancelBtn = (
      <Button onClick={props.closeModal} className='funBtn'>
        {languageData['452'][languageCode]}
      </Button>
    );

  return (
    <Modal id='modal-product-spec' show={true} onHide={props.closeModal} bsSize='large'
      keyboard={false} backdrop='static'>
      <Modal.Header>
        <Modal.Title>
          <span className='textLineHeight' style={{ float: 'left' }}>{'資料匯入'}</span>
          {cancelBtn}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className='text-center'>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>{'客戶資料'}</ControlLabel>
              <div>
                <DeleteBtnWithConfirm
                  btnTitle={'匯入'}
                  onClick={() => { props.dataImport('M_System_Customer_Import_Xls.php') }}
                />
              </div>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>{'廠商資料'}</ControlLabel>
              <div>
                <DeleteBtnWithConfirm
                  btnTitle={'匯入'}
                  onClick={() => { props.dataImport('M_System_Vender_Import_Xls.php') }}
                />
              </div>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>{'產品資料'}</ControlLabel>
              <div>
                <DeleteBtnWithConfirm
                  btnTitle={'匯入'}
                  onClick={() => { props.dataImport('M_Product_Jnh_Import_Xls.php') }}
                />
              </div>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>{'廠牌資料'}</ControlLabel>
              <div>
                <DeleteBtnWithConfirm
                  btnTitle={'匯入'}
                  onClick={() => { props.dataImport('M_Brand_Ref_Import_Xls.php') }}
                />
              </div>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>{'客戶多產品交易分析表'}</ControlLabel>
              <div>
                <DeleteBtnWithConfirm
                  btnTitle={'匯入'}
                  onClick={() => { props.dataImport('M_Report_Product_History_Import_Xls.php') }}
                />
              </div>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>{'三合一報表'}</ControlLabel>
              <div>
                <DeleteBtnWithConfirm
                  btnTitle={'匯入'}
                  onClick={() => { props.dataImport('M_31pdf_Import_Xls.php') }}
                />
              </div>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>{'借出應還跟催表'}</ControlLabel>
              <div>
                <DeleteBtnWithConfirm
                  btnTitle={'匯入'}
                  onClick={() => { props.dataImport('M_Report_Unpaid_Import_Xls.php') }}
                />
              </div>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>{'應收帳款明細表'}</ControlLabel>
              <div>
                <DeleteBtnWithConfirm
                  btnTitle={'匯入'}
                  onClick={() => { props.dataImport('M_Report_Receivable_Import_Xls.php') }}
                />
              </div>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>{'預開發票明細表'}</ControlLabel>
              <div>
                <DeleteBtnWithConfirm
                  btnTitle={'匯入'}
                  onClick={() => { props.dataImport('M_Report_Accounts_Receivable_Import_Xls.php') }}
                />
              </div>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>{'採購明細表'}</ControlLabel>
              <div>
                <DeleteBtnWithConfirm
                  btnTitle={'匯入'}
                  onClick={() => { props.dataImport('M_Report_Pruchase_Import_Xls.php') }}
                />
              </div>
            </FormGroup>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        {cancelBtn}
      </Modal.Footer>
    </Modal>
  )
};

export default class NavBarGroupCt extends React.Component {
  constructor(props) {
    super(props);

    this.handlers = {
      onToggleMenu: (stateToToggle) => {
        this.setState({ [stateToToggle]: !this.state[stateToToggle] });
      },
      onToggleLanguage: (languageCode) => {
        this.setState({ showLanguageMenu: false });
        // 更新LS
        localStorage.languageCode = languageCode;
        // 更新來源state
        this.props.stateHandler({ states: 'languageCode', newValues: languageCode });
        // 更新global物件
        window.myConsts.languageCode = languageCode;
      },
      onDataImport: () => {
        this.setState({ showDataImportModal: true })
      },
      onClickDataImport: (url) => {
        this.setState({ is_loading: true })

        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: `/api/${url}`,
          success: res => {
            this.setState({ is_loading: false })
          }
        });
      },
      onCloseDataImportModal: () => {
        this.setState({ showDataImportModal: false })
      }
    };

    this.ajaxsWip = [];

    this.state = {
      is_loading: false,
      showDataImportModal: false,
      showSettingsMenu: false,
      showLanguageMenu: false
    }
  }

  render() {
    const props = this.props, state = this.state,
      userPhotoSrc =
        props.userPhotoSrc === 'https://www.sky-family.net/'
          ? '/imgs/ic_user.svg'
          : props.userPhotoSrc,
      loading =
        state.is_loading === true ?
          <div className='loading'>
            <div className='loadingBG'></div>
            <img role='presentation' src='/imgs/loading.gif' alt='' />
          </div>
          : false;

    return (
      <div id='div-navbar-container'>
        {loading}
        <div id='div-navbar-left' className={props.isBigSideBar ? '' : 'sidebar-small'}>
          <div></div>
        </div>

        <div id='div-navbar-right' className={props.isBigSideBar ? '' : 'sidebar-small'}>
          <div id='div-company-icon-and-title-container'>
            <span
              id='span-company-icon'
              style={{ backgroundImage: `url(${props.companyInfo.logo})` }}>
            </span>
            <span id='span-company-title'>
              {props.companyInfo.title}
            </span>
          </div>

          <ToggleVisibleBtn onClick={props.onSidebarSizeToggle} />

          <span id='span-user-settings-icon' onClick={() => { this.handlers.onToggleMenu('showSettingsMenu'); }}>
            <ul style={{ display: state.showSettingsMenu ? '' : 'none' }}>
              <li className='li-settings' onClick={this.handlers.onDataImport}>資料匯入</li>
              <li className='li-settings' style={{ display: 'none' }} onClick={(e) => {
                e.stopPropagation();
                this.handlers.onToggleMenu('showLanguageMenu');
              }}>語言<div className={'tree-view_arrow' + (state.showLanguageMenu ? '' : ' tree-view_arrow-collapsed')}></div>
              </li>
              {
                state.showLanguageMenu ?
                  <div>
                    <li className='li-settings-language-list' onClick={() => { this.handlers.onToggleLanguage('zh-tw'); }}>- 繁體中文</li>
                    <li className='li-settings-language-list' onClick={() => { this.handlers.onToggleLanguage('en'); }}>- English</li>
                    <li className='li-settings-language-list' onClick={() => { this.handlers.onToggleLanguage('zh-cn'); }}>- 简体中文</li>
                    <li className='li-settings-language-list' onClick={() => { this.handlers.onToggleLanguage('ja'); }}>- 日本語</li>
                  </div>
                  : ''
              }
              <li className='li-settings' onClick={props.logoutHandler}>登出</li>
            </ul>
          </span>

          <span style={{
            display: 'inline-block',
            background: `url(${userPhotoSrc}) center no-repeat`,
            backgroundSize: 'contain',
            borderRadius: 35,
            width: 35,
            height: 35,
            margin: '7.5px 10px',
            float: 'right'
          }}>
          </span>

          <div style={{
            display: 'inline-block',
            height: 50,
            lineHeight: '50px',
            float: 'right'
          }}>
            {props.userName}
          </div>
        </div>
        {
          state.showDataImportModal ?
            <DataImportModal
              dataImport={(url) => { this.handlers.onClickDataImport(url) }}
              closeModal={() => { this.handlers.onCloseDataImportModal() }}
            />
            : ''
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/dashboard/NavBarGroupCt.jsx